// src/components/Header.js
import React, { useState } from 'react';
import { Menu, RefreshCw, Bell, Maximize, ChevronRight } from 'lucide-react';

const Header = ({ 
  title, 
  breadcrumb, 
  onToggleSidebar, 
  onRefresh, 
  onToggleFullscreen,
  totalSymbols,
  analysisCount,
  lastUpdate,
  alertCount
}) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await onRefresh();
    } finally {
      setTimeout(() => setIsRefreshing(false), 1000);
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className="header">
      <div className="header-left">
        <button className="sidebar-toggle" onClick={onToggleSidebar}>
          <Menu size={16} />
        </button>
        <h1 className="page-title">{title}</h1>
        <div className="breadcrumb">
          {breadcrumb.map((item, index) => (
            <React.Fragment key={index}>
              <span>{item}</span>
              {index < breadcrumb.length - 1 && <ChevronRight size={10} />}
            </React.Fragment>
          ))}
        </div>
      </div>
      
      <div className="header-right">
        <div className="header-stats">
          <div className="stat-item">
            <div className="stat-value">{totalSymbols || '--'}</div>
            <div className="stat-label">Symbols</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{analysisCount}</div>
            <div className="stat-label">Analyses</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{formatTime(lastUpdate)}</div>
            <div className="stat-label">Last Update</div>
          </div>
        </div>
        
        <div className="header-actions">
          <button 
            className={`header-btn ${isRefreshing ? 'spinning' : ''}`} 
            onClick={handleRefresh}
            title="Refresh Data"
          >
            <RefreshCw size={16} />
          </button>
          <button className="header-btn" title="Notifications">
            <Bell size={16} />
            {alertCount > 0 && (
              <span className="notification-count">{alertCount}</span>
            )}
          </button>
          <button className="header-btn" onClick={onToggleFullscreen} title="Toggle Fullscreen">
            <Maximize size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;